export enum PARKING_SPACE_DISPLAY_TYPE {
    OCCUPATION,
    RENTING,
    DATA_EVALUATION
}

export enum HEATMAP_COMPARISON_TYPE {
    SINGLE,
    MULTI
}